import Block from "./block";

export default class Mapping {
	constructor(blocks = {}) {
		this.blocks = blocks
			? Object.entries(blocks).reduce((acc, [key, blockValue]) => {
					const blockString =
						typeof blockValue === "string"
							? blockValue
							: JSON.stringify(blockValue);
					const replacedString = blockString.replace(/None/g, "null");
					const block = JSON.parse(replacedString.replace(/'/g, '"'));
					acc[key] = new Block(block);
					return acc;
			  }, {})
			: {};
	}
	getBlocks() {
		return this.blocks;
	}
}
